export function initBookingFlow() {
  const modal = document.getElementById('booking-modal');
  const openBtn = document.querySelector('.cta-fixed-bottom .btn-cta');
  const closeBtn = document.getElementById('modal-close');
  const form = document.getElementById('charter-form');

  if (!modal || !openBtn || !closeBtn || !form) return;

  // Open Modal
  openBtn.addEventListener('click', () => {
    modal.classList.add('open');
  });

  // Close Modal
  closeBtn.addEventListener('click', () => {
    modal.classList.remove('open');
  });

  // Close Modal on clicking outside the card
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.classList.remove('open');
    }
  });

  // Handle Form Submission
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const submitBtn = form.querySelector('.btn-submit');
    const textEl = submitBtn.querySelector('.btn-text');
    const loaderEl = submitBtn.querySelector('.btn-loader');

    // Show loading state
    if (textEl && loaderEl) {
      textEl.style.display = 'none';
      loaderEl.style.display = 'inline-block';
    }

    // Get Form Data
    const name = document.getElementById('booking-name').value;
    const email = document.getElementById('booking-email').value;
    const phone = document.getElementById('booking-phone').value;
    const departure = document.getElementById('booking-departure').value;
    const destination = document.getElementById('booking-destination').value;
    const date = document.getElementById('booking-date').value;
    const passengers = document.getElementById('booking-passengers').value;
    const aircraft = document.getElementById('booking-aircraft').value;
    const requirements = document.getElementById('booking-requirements').value;

    // Success animation timeout (600ms)
    setTimeout(() => {
      // Build WhatsApp message
      const message = `✈️ New Charter Flight Inquiry

Name: ${name}
Email: ${email}
Phone: ${phone}

Departure: ${departure}
Destination: ${destination}
Travel Date: ${date}
Passengers: ${passengers}
Preferred Aircraft: ${aircraft}

Additional Requirements:
${requirements || 'None'}

Please contact me regarding this private jet charter.`;

      const whatsappURL = `https://wa.me/919036024148?text=${encodeURIComponent(message)}`;
      
      // Open in new tab
      window.open(whatsappURL, '_blank');

      // Reset loading state and close modal
      if (textEl && loaderEl) {
        textEl.style.display = 'inline-block';
        loaderEl.style.display = 'none';
      }
      modal.classList.remove('open');
      form.reset();
    }, 600);
  });
}
